// src/components/notary-view-open-request.js

import React, { useState, Suspense, useEffect, Fragment} from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { RestHelper } from '../helper/restHelper'



const NotaryViewOpenRequest = (data, data2) => {  

  const [requestDetails, setRequestDetails] = useState([])
  const [offerDetails, setOfferDetails] = useState([])
  const [offerSent, setOfferSent] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [counter, setCounterBid] = useState('$0.00')
  const [bid, setInitialBid] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [showClaimForm, setShowClaimForm] = useState(false)
  const [showCounterForm, setShowCounterForm] = useState(false)
  const [showOptions, setShowOptions] = useState(false)
  const [showAppt, setShowAppt] = useState(false)
  const [counterWarning, setCounterWarning] = useState(false)
  const api = RestHelper()
  console.log('Incoming data for the view open request', data, data2)

  const onClickHandler = (action) => {
    if (action == 'claim') {
      setIsLoading(true)
      setShowClaimForm(false)
      setShowAppt(false)
      updateRequest({'Action': 'accept', 'Bid' : bid})
    }
    if (action == 'counter') {
      setShowClaimForm(false)
      setShowAppt(false)
      setShowCounterForm(true)
    }
    if (action == 'decline') {
      setIsLoading(true)
      setShowClaimForm(false)
      setShowAppt(false)
      updateRequest({'Action': 'decline', 'Bid' : bid})
    }
  }

  const onSubmitCounterHandler = () => {
    const submitValue = {'Action':'counter', 'Bid' : counter}
    console.log({counter}.counter)
    if ({counter}.counter=='$0.00'){
        console.log('made it here for counter')
        setCounterWarning(true)
        setOfferSent(true)
    }
    else{
        setCounterWarning(false)
        setInitialBid(counter)
        updateRequest(submitValue)
    }
  }
  const inputChangeHandler = (setFunction: React.Dispatch<React.SetStateAction<string>>, event: React.ChangeEvent<HTMLInputElement>) => {
    setFunction(event.target.value)
}
  const reqData = { data, data2 }
  const options = {}
  if(!isLoaded){
    api
        .postCreate('/get-request-details', options, reqData)
        .then(res => setDetails(res))
        .catch(err => console.log(err))
    setIsLoaded(true)
    }
  
    const onChangeEvent = (evt) => {
      const value = evt.target.value;
      setCounterBid(value)
    }

  
    const onSubmitHandler = () => {
      setIsLoading(true)
      setShowClaimForm(false)
      setShowAppt(false)
      setShowCounterForm(false)
      updateRequest({'Action': 'counter', 'Bid' : counter})
    }

    const scanBackCheck = (checkFlag) => {
      var scanBackValue = ''
      if (checkFlag === 'true') {
        scanBackValue = 'SCAN BACKS ARE REQUIRED'
      }
      else{
        scanBackValue = 'NONE'
      }
      return scanBackValue
  
    }

    function setTransactionType(setValue) {
      if (setValue === '0') {
        return 'Not Defined'
      }
      else if (setValue === '1') {
        return 'Purchase'
      }
      else if (setValue === '2') {
        return 'Refinance'
      }
      else if (setValue === '3') {
        return 'Sellers Deed Set'
      }
      else if (setValue === '4') {
        return 'Other'
      }
      else {
        return 'Not Defined'
      }
    }
  
    function setFinanceType(setValue) {
      if (setValue === '10') {
        return 'Not Defined'
      }
      else if (setValue === '11') {
        return 'FHA'
      }
      else if (setValue === '12') {
        return 'Conventional'
      }
      else if (setValue === '13') {
        return 'Reverse'
      }
      else if (setValue === '14') {
        return 'HELOC'
      }
      else if (setValue === '15') {
        return 'Commercial'
      }
      else if (setValue === '16') {
        return 'VA'
      }
      else {
        return 'Not Defined'
      }
    }

    const dateFormat = (inputDate) => {
      const dateArray = inputDate.split("-")
      const date = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0]
      return date
    }
 const setDetails = (res) => {
      setRequestDetails(res)
      setShowOptions(true)
      setInitialBid(res[0]['apptOffer'])
      setIsLoading(false)
    }
  const updateRequest= (action) => {
    const updateDetails = {reqData, action}
    api
        .postCreate('/update-notary-request-details', options, updateDetails)
        .then(res => setOfferDetails(res))
        .catch(err => console.log(err))
    setOfferSent(true)
    setIsLoading(false)
  }

  return(
    <div className="bg-white rounded-xl shadow-md p-6 border border-neutral-200 mt-2 mb-2">
      {isLoading &&
       (<div className="flex justify-center mb-4 mt-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-blue"></div>
         </div>)}
    {offerSent
        ? offerDetails.map((items =>
            <div className="p-4 bg-neutral-50 rounded-lg"><p className="text-neutral-700">{items.responseMessage}</p></div>))
        : (
        <div>
        {requestDetails.map((items =>
                <div className="space-y-1">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className='font-medium text-neutral-600'>Appointment Name</div>
                      <div className='sm:col-span-2 text-neutral-800 break-words'>{items.apptName}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className='font-medium text-neutral-600'>Signing Agent Fee</div>
                      <div className='sm:col-span-2 text-neutral-800'>${items.apptOffer}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className='font-medium text-neutral-600'>Lender</div>
                      <div className='sm:col-span-2 text-neutral-800 break-words'>{items.lender}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className='font-medium text-neutral-600'>When</div>
                      <div className='sm:col-span-2 text-neutral-800'>{dateFormat(items.apptDate)} at {items.apptTime} {items.appt_timeZone}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className='font-medium text-neutral-600'>Where</div>
                      <div className='sm:col-span-2 text-neutral-800 break-words'>{items.apptStreet} {items.apptCity}, {items.apptState} {items.apptZip}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className="font-medium text-neutral-600">Scan Backs</div>
                      <div className="sm:col-span-2 text-neutral-800">{scanBackCheck(items.scanBack)}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className="font-medium text-neutral-600">Transaction Type</div>
                      <div className="sm:col-span-2 text-neutral-800">{setTransactionType(items.transactionType)}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className="font-medium text-neutral-600">Finance Type</div>
                      <div className="sm:col-span-2 text-neutral-800">{setFinanceType(items.financeType)}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                      <div className='font-medium text-neutral-600'>Extra Notes</div>
                      <div className='sm:col-span-2 text-neutral-800 break-words whitespace-pre-wrap'>{items.apptMessages}</div>
                    </div>
                </div>
                ))}
              {showOptions && (
              <div className="mt-6 pt-6 border-t border-neutral-200">
                <p className="text-neutral-600 mb-4">Please select an option below to either claim the offer, propose a counter offer, or decline this offer:</p>
                <div className="flex flex-wrap gap-3">
                 <button type='button' className="btn btn-primary" onClick={()=>onClickHandler('claim')}>Claim</button>
                 <button type='button' className="btn btn-secondary" onClick={()=>onClickHandler('counter')}>Counter</button>
                 <button type='button' className="btn btn-secondary" onClick={()=>onClickHandler('decline')}>Decline</button>
                </div>
              </div>)}
            </div>)}
            {counterWarning && <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg mt-4"><p className="text-yellow-800">Please enter a valid counter offer.</p></div>}
            {showClaimForm &&
            <div className="mt-4 p-4 bg-neutral-50 rounded-lg border border-neutral-200">
                <p className="text-neutral-600">{updateRequest}</p>
            </div>
          }
          {showCounterForm &&
            <div className="mt-6 p-5 bg-neutral-50 rounded-lg border border-neutral-200">
                   <h5 className="text-lg font-semibold text-neutral-800 mb-4">Counter Offer</h5>
                   <form onSubmit={onSubmitHandler}>
                   <div className="mb-4">
                    <label htmlFor="counterOffer" className='block text-sm font-medium text-neutral-700 mb-2'>Enter an offer in a whole dollar amount (Current Offer = {bid}):</label>
                    <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-brand-blue focus:border-brand-blue' id="counterOffer" onChange={(e)=>onChangeEvent(e)} pattern="^-?[0-9]\d*\.?\d*$" type="tel" placeholder='0.00' required/>
                   </div>
                   <button className='btn btn-primary' type="submit">Submit</button>
                   </form>
            </div>
          }
</div>
  )
};

export default NotaryViewOpenRequest;